module.exports = __webpack_public_path__ + "media/images/liv_logo-89bc22bcca10214e492c46538b3edeba.png";